// Brand color tokens for MLAP chart code (places where Tailwind classes
// can't be used — Highcharts series options, computed style strings, etc.).
//
// tailwind.config.cjs reads the same brandColors.json. Do not copy the values here or in component files.
import brandColors from '@/config/brandColors.json'

const {
  PRIMARY, SUCCESS, MLAP_DASHBOARD_TEAL, GRAY, VIOLET, WHITE
} = brandColors

// A single series uses slot 1. Tailwind has the same colors as `mlap-chart-1` and `mlap-chart-2`.
export const MLAP_CHART = Object.freeze({ 1: PRIMARY[600], 2: VIOLET[500] })

// The series colors on the dark surface of Present mode. Do not invert MLAP_CHART for dark.
export const MLAP_CHART_DARK = Object.freeze({ 1: PRIMARY[500], 2: VIOLET[600] })

export {
  PRIMARY, SUCCESS, MLAP_DASHBOARD_TEAL, GRAY, WHITE
}

// Categorical 20-color palette for MLAP geographic / territory series —
// alternates brand blue with success green, walking each scale in a
// previously-tuned order. Order is load-bearing: existing chart call
// sites rely on positional indexing into this array.
export const SERIES_PALETTE = [
  PRIMARY[600], SUCCESS[600], PRIMARY[400], SUCCESS[700], PRIMARY[500],
  SUCCESS[500], PRIMARY[800], SUCCESS[800], PRIMARY[300], SUCCESS[300],
  PRIMARY[700], SUCCESS[900], PRIMARY[200], SUCCESS[200], PRIMARY[900],
  SUCCESS[400], PRIMARY[100], SUCCESS[100], PRIMARY[950], SUCCESS[950]
]
